import { PureComponent } from 'preact-compat'
import { getPostOffset } from '../utils'

export interface ReplyPillsProps {
  id?: string
  publicReplyId?: string
  trashed: boolean
  spam: boolean
  pending: boolean
  author?: boolean
  replyNumber: number
  replyCount: number
  pinned?: boolean
  answer?: boolean
}

class ReplyPills extends PureComponent<ReplyPillsProps> {
  render() {
    const { trashed, spam, replyNumber, replyCount, pinned, pending, author, answer, publicReplyId } = this.props

    return (
      <div className='pull-right pill-container'>
        {spam && <span className='pill pill--spam'>spam</span>}
        {pending && <span className='pill pill--pending'>pending</span>}
        {trashed && <span className='pill pill--trashed'>trashed</span>}
        {pinned && !trashed && <span className='pill pill--pin'>pin</span>}
        {author && !trashed && <span className='pill pill--author'>author</span>}
        {answer && <span className='pill pill--answer'>answer</span>}
        <a
          onClick={() => {
            if (publicReplyId) {
              const postOffset = getPostOffset(publicReplyId)
              window.location.hash = `#postid/${publicReplyId}`
              window.scrollTo({ behavior: 'smooth', top: postOffset })
            }
          }}
          className='pill pill--counter'
        >{replyNumber} of {replyCount}</a>
      </div>
    )
  }
}

export default ReplyPills
